<template>
  <v-container>
    <confirm-box :dialog="dialog" @confirmed="deleteTownship" @cancel="cancel" />
    <v-row>
      <v-col lg="4">
        <outside-township-form @emitOutsideTownshipData="emitData"></outside-township-form>
      </v-col>
      <v-col lg="8">
        <div>
          <v-data-table
            :headers="headers"
            :items="outsideTownships"
            :loading="loading"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            :page.sync="page"
            item-key="id"
            hide-default-footer
            hide-default-header
          >
            <template v-slot:top></template>

            <template v-slot:header="{ props: { headers } }">
              <thead class="header">
                <tr>
                  <th
                    v-for="header in headers"
                    :key="header.text"
                    class="header--text"
                  >{{ header.text }}</th>
                  <th class="header--text">Actions</th>
                </tr>
              </thead>
            </template>

            <template v-slot:item="{ index, item }">
              <tr class="center-tb">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>
                  <v-btn
                    @click="goUpdateForm(item)"
                    icon
                    color="orange darken-1"
                    class="mr-2 white--text"
                    depressed
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn
                    @click="openConfrimBox(item)"
                    icon
                    color="red lighten-1"
                    class="white--text"
                    depressed
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div class="text-center py-3">
            <v-pagination color="purple accent-4" v-model="page" :length="pageCount"></v-pagination>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OutsideTownshipForm from "@/components/outside_township/OutsideTownshipForm.vue";
import ConfirmBox from "@/components/notification/ConfirmBox";
import { mapState } from "vuex";
export default {
  components: {
    OutsideTownshipForm,
    ConfirmBox
  },
  methods: {
    emitData(data) {
      this.$store.dispatch("OutsideTownship/create", data);
    },
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteTownship() {
      let data = {
        id: this.item.id
      };
      this.$store
        .dispatch("OutsideTownship/deleteTownship", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "edit-outside-township",
        params: {
          id: convertNumber
        }
      });
    }
  },
  created() {
    this.$store.dispatch("OutsideTownship/getAll", {
      township_id: this.$route.params.township_id
    });
  },
  computed: {
    ...mapState("OutsideTownship", ["outsideTownships"]),
    ...mapState("Loading", ["loading"])
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" }
    ]
  })
};
</script>

<style scoped>
</style>